<template>
  <div>
    <yw-head></yw-head>
      <div class="web-body">
        <div class="banner-size">
          <div class="product-box">
            <b-map-component></b-map-component>
            <div class="menu-ul">
              <router-link to="/about/company">公司</router-link>
              <router-link to="/about/media">媒体</router-link>
              <router-link to="/cooperation">合作</router-link>
            </div>
            <div class="contact-div">
              <div><h1>联系地址</h1><span>广州市<br>天河区 珠江东路30号 广州银行大厦<br>6楼601A</span></div>
              <div><h1>商务合作</h1><span>bryan@yongwangkeji.cn</span></div>
              <div><h1>商务邮箱</h1><span>bryan@yongwangkeji.cn</span><br>
                <h1>简历投递</h1><span>zengjiaxin@yongwangkeji.cn</span></div>

            </div>
          </div>
        </div>
      </div>
      <yw-footer></yw-footer>
    </div>
</template>

<script>
  import yw_head from './yw_head';
  import yw_footer from './yw_footer';

  import BMapComponent from './BMapComponent';

  export default {
    name: "cooperation",
    components: {
      'b-map-component': BMapComponent,
      'yw-head': yw_head,
      'yw-footer': yw_footer
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cooperation.vue